import { ContractStatusEnum } from '../../enums/contract-status.enum';

export type bubbleColor = 'red' | 'yellow' | 'blue' | '';

export enum BUBBLE_COLOR_ENUM {
  RED = 'red',
  YELLOW = 'yellow',
  BLUE = 'blue',
  EMPTY = '',
}

/**
 * Marqueur affiché devant la valeur d'une colonne texte (ex. étoile « Conforme PA/PREDIK360 » fournisseur) :
 * une icône Material (`icon`, colorée par `iconColor`) si fournie, sinon une pastille ronde de couleur (`color`).
 */
export interface ColumnIndicator {
  color?: bubbleColor;
  icon?: string;
  iconColor?: string;
  tooltip?: string;
}

export interface FeiColumn {
  statusClassFunc?: (element: any) => bubbleColor;
  /** Marqueur (icône ou pastille) après la valeur : retourner `null` pour ne rien afficher. Se cumule avec `statusClassFunc`. */
  indicatorFunc?: (element: any) => ColumnIndicator | null;
  previousDisplay?: string;
  label: string;
  column: 'actions' | string;
  width?: 'auto' | string;
  minWidth?: string;
  wrap?: boolean;
  propertyDisplay?: string | ContractStatusEnum;
  overrideDisplay?: string;
  titleCase?: boolean;
  upperCase?: boolean;
  canUpdate?: boolean;
  canDelete?: boolean;
  canUpdateDynamically?: (element: any) => boolean;
  canDeleteDynamically?: (element: any) => boolean;
  showAction?: boolean;
  showActionDynamically?: (element: any) => boolean;
  canDuplicate?: boolean;
  canFavorite?: boolean;
  canArchive?: boolean;
  canSuspend?: boolean;
  canChangeStatus?: boolean;
  canDownload?: boolean;
  type?:
    | 'text'
    | 'boolean'
    | 'booleanQuote'
    | 'date'
    | 'number'
    | 'category'
    | 'technicalIdentifier'
    | 'catalogue'
    | 'dateTime'
    | 'notificationStatus'
    | 'eshopStatus'
    | 'custom'
    | 'attentionRequiered'
    | 'interventionRequired'
    | 'favorite'
    | 'isSpecialConditions';
  customColHeader?: boolean;
  additionalDisplay?: string;
  checkboxTooltip?: string;
  value?: any;
  status?: 'enabled' | 'disabled';
  customDisplay?: any;
  click?: (element: any) => void;
  customExtraHtml?: string;
  isPredik?: boolean;
  canSort?: boolean;
  maxDecimal?: number;
  canCreate?: boolean;
  statusPipe?: string;
}
